import React from 'react';
import Layout from '../components/Layout';
// @ts-ignore
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getLegalNotice } from '../utils/api';
import Banner from '../components/Banner/Banner';
import DefaultPageLayout from '../components/DefaultPageLayout/DefaultPageLayout';
import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Mentions = ({ data }) => {
  return (
    <Layout pathRoot={'Mentions légales'}>
      <Banner title={data.title} />
      <DefaultPageLayout textContent={data.content} />
    </Layout>
  );
};

export default Mentions;

export async function getStaticProps({ params }) {
  const data = await getLegalNotice();

  return {
    props: {
      data: data ?? null,
    },
  };
}
